import { store } from "../store/index";
import {
  filterReport,
  createReport,
  getReportByUuid,
  modifyReport,
  removeReport,
  filterAllReport,
  filterOne,
  allSkills,
} from "../store/actions/ReportActions";

/**
 * Create Report
 */
export const addReport = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createReport(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Report
 */
export const getReport = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getReportByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Report
 */
export const updateReport = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyReport(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Report
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterReport(filter));
  if (result?.payload?.data) {
    return { data: result.payload.data, skills: result.payload.skills };
  }
  return null;
};

/**
 * Delete Report
 */
export const deleteReport = async (uuid) => {
  const result = await store.dispatch(removeReport([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const listAllFilter = async (filter) => {
  const result = await store.dispatch(filterAllReport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const filterOneReport = async (filter) => {
  const result = await store.dispatch(filterOne(filter));
  if (result && result.payload && result.payload.data) {
    return { data: result.payload.data, skills: result.payload.skills };
  }
  return null;
};

export const getProfessionalSkills = async () => {
  const result = await store.dispatch(allSkills());
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

// /**
//  * List all Form
//  */
// export const listAllFilter = async (filter) => {
//   const result = await store.dispatch(filterAllReport(filter));
//   if (result?.payload?.data) {
//     return result.payload.data;
//   }
//   return null;
// };
